import dayjs from 'dayjs'

import { ActivityHistoryAvatar } from './activity-history-avatar'
import { getActorDisplay } from '../model/actor-display'
import { AVATAR_TONE } from '../model/types'
import type { ActivityHistoryEventEntry } from '../model/types'

const TIME_FORMAT = 'h:mm A'

interface ActivityHistoryEventRowProps {
  entry: ActivityHistoryEventEntry
}

export function ActivityHistoryEventRow({
  entry,
}: ActivityHistoryEventRowProps) {
  const { user, occurredAt, label, detail } = entry
  const time = dayjs(occurredAt).format(TIME_FORMAT)
  const fullName = getActorDisplay(user).name
  return (
    <div className="flex items-center gap-3 px-4 py-2">
      <ActivityHistoryAvatar
        initials="+"
        tone={AVATAR_TONE.gray}
        className="border border-gray-200"
      />
      <div className="flex flex-col gap-1 leading-none">
        <div className="flex items-baseline gap-1.25 text-sm">
          <span className="font-medium text-gray-900">{fullName}</span>
          <span className="text-gray-500">{label}</span>
        </div>
        <p className="text-xs text-gray-500">
          {time}
          {detail ? ` · ${detail}` : ''}
        </p>
      </div>
    </div>
  )
}
